import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Player } from '@/types/player';

interface PlayerContactInfoProps {
  player: Player | null;
}

export const PlayerContactInfo = ({ player }: PlayerContactInfoProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Contact & Team Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-4">
            <div>
              <Label>Email</Label>
              <p className="text-sm">{player?.profile?.email}</p>
            </div>
            {player?.teams && (
              <>
                <div>
                  <Label>Current Team</Label>
                  <p className="text-sm">{player.teams.name}</p>
                </div>
                <div>
                  <Label>Club</Label>
                  <p className="text-sm">{player.teams.clubs?.name}</p>
                </div>
              </>
            )}
          </div>
          <div className="space-y-4">
            {player?.teams && (
              <div>
                <Label>Organization</Label>
                <p className="text-sm">{player.teams.clubs?.organizations?.name}</p>
              </div>
            )}
            <div>
              <Label>Join Date</Label>
              <p className="text-sm">
                {player?.join_date ? new Date(player.join_date).toLocaleDateString() : 'Not specified'}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};